import { Suspense, lazy } from "react";
import { componentLoader } from "@/utils";

const LottieLoading = lazy(() => componentLoader(() => import(/* webpackPreload: true */ "./lottieLoading"), 3));

const Loading = () => (
  <Suspense fallback={null}>
    <LottieLoading />
  </Suspense>
);

export default Loading;
